// @flow

/**
 * Convert ficus node's path to something human readable
 * @param ficusNode
 * @returns {string}
 */
export const getFicusPathFromNode = (ficusNode: string) => ficusNode.replace(/\//g, ' > ')
export const isTemporalTheme = theme => theme.toLowerCase().indexOf('temporal') >= 0
export const isTransimTheme = theme => theme.toLowerCase().indexOf('transims') >= 0
